import { Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

export const MissingDataInfo = ({ children }: PropsWithChildren) => {
    return (
        <Typography sx={{ display: 'inline-block', padding: 0.5 }} variant="minorLabel">
            {children}
        </Typography>
    );
};
